'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const Formatters=require('../../../../dist-es6/client/formatters');let

PersonalScheduleController=(_class=class PersonalScheduleController extends BaseController{
constructor(
$scope,
$state,
$window,
$timeout,
$modal,
personalScheduleDataService,
socketService,
breadcrumbsService,
displaySettingsService,
uiCommandFactory,
paramSyncService,
userService,
fatigueMeterTypeContentProviderService,
uncaughtErrorHandler){
super(uncaughtErrorHandler,$timeout);

this._assignParamsToController($state.params);

this._updateUrlParamsFromController=paramSyncService.start(this,$scope,newParams=>this._updateControllerParamsFromUrl(newParams));

this._$state=$state;
this._$window=$window;
this._$timeout=$timeout;
this._$modal=$modal;

this.weekFormatter=this.weekFormatter.bind(this);
this.groupFormatter=this.groupFormatter.bind(this);

this._socketService=socketService;
this._breadcrumbsService=breadcrumbsService;
this._displaySettingsService=displaySettingsService;
this._personalScheduleDataService=personalScheduleDataService;
this._userService=userService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this._fatigueThreshold=null;
this.hideEverything=!0;
this._isLoadingDifferentWeek=!0;

this._planRouteCommand=uiCommandFactory.make(this._onPlanRoute.bind(this));
this.openFatigueReport=()=>this._openFatigueReport();

this.graphSubViewConfiguration=this._getGraphSubViewConfiguration();

breadcrumbsService.dropCrumb('Personal Schedule');

$scope.$watch('controller.selectedWeek',(newSelectedWeek,oldSelectedWeek)=>{
if(!_.exists(newSelectedWeek)){
return;
}

if(newSelectedWeek===oldSelectedWeek){
const existingQueryInterval=_.get(this._personalStatistics,'queryInterval');
if(existingQueryInterval&&newSelectedWeek.equals(existingQueryInterval)){
return;
}
}

this._startLoadingDataForSelectedWeek();
});

this._startLoading();
}

_updateControllerParamsFromPersonInfo(personInfo){
this._personId=personInfo.id;
this._employeeId=personInfo.employeeId;
this._updateUrlParamsFromController({
id:this._personId,
employeeId:this._employeeId});

}


async _startLoading(){
const response=await this._personalScheduleDataService.tryGetPersonInfoAndWeeksInQueryInterval(
{id:this._personId,employeeId:this._employeeId},
this._queryInterval,
this._timezone);

if(_.exists(response.error)){
if(response.error==='NotFound'){
this._$state.go(this._fatigueMeterTypeContentProviderService.defaultFeature);
}
return;
}


if(!_.exists(this._timezone)){
this._$timeout(()=>{
this.hideEverything=!0;
this._$state.go('fdc.features.personalSchedule',{timezone:response.personInfo.homeTimezone});
});
return;
}


this._$timeout(()=>{
if(!_.isEqual(response.personInfo,this._personInfo)){
this._updateControllerParamsFromPersonInfo(response.personInfo);
}
this._personInfo=response.personInfo;
this._availableWeeks=response.weeksInQueryInterval;
this._selectedWeek=this._availableWeeks[0];

const{firstName,lastName}=this._personInfo;
const newWindowTitle=`${firstName} ${lastName} (${this.weekFormatter(this._selectedWeek)})`;
this._breadcrumbsService.updateLabelForState(newWindowTitle,'fdc.features.personalSchedule');
});
}


async _startLoadingDataForSelectedWeek(){
this._isLoadingDifferentWeek=!0;

let{
weekSectionModels,
now,
timeOfLastScheduleUpdate,
timeOfLastHosStatus,
invalidDataWarning,
predictedWorkday,
forecastDutyInterval,
estimatesAsOfTime,
fatigueThreshold,
deviationThreshold,
groupMemberships,
displayTimeZone}=
await this._personalScheduleDataService.getScheduleDataFor(this._personInfo,[this._selectedWeek],this._timezone);

let{personalStatistics,personalSchedule,dailySchedules}=weekSectionModels[0];

if(!personalStatistics.queryInterval.equals(this._selectedWeek)){

return;
}

this._$timeout(()=>{
this._personalStatistics=personalStatistics;
this._personalSchedule=personalSchedule;
this._dailySchedules=dailySchedules;
this._fatigueThreshold=fatigueThreshold;
this._deviationThreshold=deviationThreshold;
this._groupMemberships=groupMemberships;
this._now=now,
this._timeOfLastScheduleUpdate=timeOfLastScheduleUpdate;
this._timeOfLastHosStatus=timeOfLastHosStatus;
this._invalidDataWarning=invalidDataWarning;
this._predictedWorkday=predictedWorkday;
this._forecastDutyInterval=forecastDutyInterval;
this._estimatesAsOfTime=estimatesAsOfTime;
this._displayTimeZone=displayTimeZone;

if(_.exists(this.multiView)){
this.multiView.reloadCurrentView();
}

this.hideEverything=!1;
this._isLoadingDifferentWeek=!1;
});
}

_getGraphSubViewConfiguration(){

const controllerPropertiesToBindToSubViews=[
'personInfo',
'displayTimeZone',
'timezoneDescription',
'estimatesAsOfTime',
'timezone',
'homeTimezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'deviationThreshold',
'now',
'timeOfLastScheduleUpdate',
'timeOfLastHosStatus',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'dutyFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'tripFormatter',
'flightFormatter',
'personalStatistics',
'groupMemberships'];


const rasterSubview={
label:'Schedule',
buttonClass:'day-to-day-button',
directiveName:'pulsar-raster-schedule'};


const timelineSubview={
label:'Timeline',
buttonClass:'timeline-button',
directiveName:'pulsar-timeline-schedule'};


const incidentsSubview={
label:'Incidents',
buttonClass:'sces-button',
directiveName:'pulsar-incidents-schedule'};


let activeSubviews;
switch(_.get(this._userService,'currentUser.fatigueMeterType')){
case FatigueMeterType.WorkforceAviation:
activeSubviews=[rasterSubview];
break;
case FatigueMeterType.Aviation:
activeSubviews=[timelineSubview,rasterSubview];
break;
default:
activeSubviews=[rasterSubview,timelineSubview,incidentsSubview];}


return ControllerExtensions(this).getMultiViewConfigurationFor(controllerPropertiesToBindToSubViews,activeSubviews);
}

_assignParamsToController(params){
this._employeeId=params.employeeId;
this._personId=params.id;
this._queryInterval=params.interval;
this._timezone=params.timezone;
}

_updateControllerParamsFromUrl(newStateParams){
let{id,interval,timezone,employeeId}=newStateParams;

if(this._personId===id&&
this._employeeId===employeeId&&
this._queryInterval&&this._queryInterval.equals(interval)&&
this._timezone===timezone){
return;
}

this._assignParamsToController(newStateParams);
this._startLoading();
}

_openFatigueReport(){
if(!_.exists(this,'personalSchedule.bounds.end')){
return;
}

const previousWeek=this.selectedWeek.shift('days',-7,this._timezone);

const url=this._$state.href('fdc.features.fatigueReport',{
id:this._personId,
interval:TimeInterval.from(previousWeek.start).to(this.selectedWeek.end),
timezone:this._timezone,
notificationType:this._displaySettingsService.stickySettings.get('selectedNotificationType')||NotificationType.AllThresholdsExceeded});


this._$window.open(url,'_blank');
}

onPlanRoute(){
return this._planRouteCommand.execute();
}


async _onPlanRoute(){
let statusInfo=await this._socketService.sendAndWaitForResponse('GetLastKnownStatus',{
personId:this._personId,
includeGeocodeDetails:!0});


let modalInstance=this._$modal.open({
templateUrl:'/templates/features/personalSchedule/modals/scenarioSetupModalView',
controller:'ScenarioSetupModalController as controller',
resolve:{
personId:()=>this._personId,
originAddress:()=>this._getFormattedAddressFromStatusInfo(statusInfo)}});



modalInstance.result.then(routeScenarioResponse=>{
this._$state.go('fdc.features.scenario',{
personInfo:this._personInfo,
originalInputs:routeScenarioResponse.originalInputs,
schedule:routeScenarioResponse.schedule,
route:routeScenarioResponse.route,
queryInterval:routeScenarioResponse.queryInterval,
fatigueThreshold:this._fatigueThreshold});

});
}

_getFormattedAddressFromStatusInfo(statusInfo){
if(!_.exists(statusInfo.geocodeDetails)){
if(!_.exists(statusInfo.location)){
return'';
}

if(_.exists(statusInfo.location.description)&&statusInfo.location.description!==''){
return statusInfo.location.description;
}

return`${statusInfo.location.lat}, ${statusInfo.location.long}`;
}

let{
streetNumber,
streetName,
city,
stateCode,
zipcode}=
statusInfo.geocodeDetails;

return`${streetNumber} ${streetName}, ${city}, ${stateCode} ${zipcode}`;
}

groupFormatter(group){
return group.name;
}

weekFormatter(weekInterval){
let weekStartString=moment(weekInterval.start).tz(this.timezone).format('MMM DD');
let weekEndString=moment(weekInterval.end-1).tz(this.timezone).format('MMM DD, YYYY');

return`${weekStartString} – ${weekEndString}`;
}

_safeThresholdStatusGetter(propertyName){
let fatigue=_.get(this,`personalStatistics.${propertyName}`);

return this._personalScheduleDataService.getThresholdStatus(fatigue,this.fatigueThreshold);
}

get selectedWeek(){
return this._selectedWeek;
}

set selectedWeek(selectedWeek){
this._selectedWeek=selectedWeek;
}

get tripFormatter(){
if(!_.exists(this._tripFormatter)&&_.exists(this._use24HourTimeline)){
this._tripFormatter=this._use24HourTimeline?Formatters.tripLabel_24Hour():Formatters.tripLabel();
}
return this._tripFormatter;
}

get flightFormatter(){
if(!_.exists(this._flightFormatter)&&_.exists(this._use24HourTimeline)){
this._flightFormatter=this._use24HourTimeline?Formatters.flightLabel_24Hour():Formatters.flightLabel();
}
return this._flightFormatter;
}

get dutyFormatter(){
if(!_.exists(this._dutyFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._dutyFormatter=Formatters.dutyLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline);
}
return this._dutyFormatter;
}

get sleepFormatter(){
if(!_.exists(this._sleepFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._sleepFormatter=Formatters.sleepLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline);
}
return this._sleepFormatter;
}

get sleepPromotingFormatter(){
if(!_.exists(this._sleepPromotingFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._sleepPromotingFormatter=Formatters.sleepLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline,'Sleeper Berth');
}
return this._sleepPromotingFormatter;
}

get showLoadingSpinner(){
return this.hideEverything||this._isLoadingDifferentWeek||!_.exists(this._timezone);
}

get timezoneDescription(){
return this.homeTimezone===this.timezone?_.get(this,'_personInfo.initialLocation.description'):this.timezone;
}

get homeTimezone(){
return _.get(this,'_personInfo.homeTimezone');
}

get timezone(){
return this._timezone;
}

get displayTimeZone(){
return this._displayTimeZone;
}

get availableWeeks(){
return this._availableWeeks;
}

get personInfo(){
return this._personInfo;
}

get personalSchedule(){
return this._personalSchedule;
}

get fatigueThreshold(){
return this._fatigueThreshold;
}

get deviationThreshold(){
return this._deviationThreshold;
}

get groupMemberships(){
return this._groupMemberships;
}

get timeOfLastScheduleUpdate(){
return this._timeOfLastScheduleUpdate;
}

get now(){
return this._now;
}

get invalidDataWarning(){
return this._invalidDataWarning;
}

get timeOfLastHosStatus(){
return this._timeOfLastHosStatus;
}

get predictedWorkday(){
return this._predictedWorkday;
}

get forecastDutyInterval(){
return this._forecastDutyInterval;
}

get estimatesAsOfTime(){
return this._estimatesAsOfTime;
}

get dailySchedules(){
return this._dailySchedules;
}

get personalStatistics(){
return this._personalStatistics;
}

get peakThresholdStatus(){
return this._safeThresholdStatusGetter('maxFatigueOnDuty');
}

get averageThresholdStatus(){
return this._safeThresholdStatusGetter('averageFatigueOnDuty');
}},(_applyDecoratedDescriptor(_class.prototype,'_startLoading',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startLoading'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_startLoadingDataForSelectedWeek',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startLoadingDataForSelectedWeek'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onPlanRoute',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onPlanRoute'),_class.prototype)),_class);


module.exports=PersonalScheduleController;
//# sourceMappingURL=personalScheduleController.js.map
